import React from 'react';
import PropTypes from 'prop-types';
import Item from './item';

import { ABSOLUTE, RELATIVE, VALUE } from '../../../../constants';

export default function Statistics(props) {
  const {
    countries, global, targetCountryISO2, param, quality, period,
  } = props;
  let copyCountries = [...countries];

  const casesParam = period + param;

  if (targetCountryISO2) {
    copyCountries = [copyCountries.find((country) => country.CountryCode === targetCountryISO2)];
  }

  if (countries.length > 1 && quality === ABSOLUTE) {
    copyCountries.sort((a, b) => b[casesParam] - a[casesParam]);
  }

  if (countries.length > 1 && quality === RELATIVE) {
    copyCountries.sort((a, b) => {
      const valueB = b[casesParam];
      const valueA = a[casesParam];
      const resultB = (valueB * VALUE) / b.population;
      const resultA = (valueA * VALUE) / a.population;
      return resultB - resultA;
    });
  }

  return (
    <div className="statistics">
      <div className="global" param={param}>
        <span className="span">Global:</span>
        <span className="span">
          {new Intl.NumberFormat({ useGrouping: 'true' }).format(global[casesParam])}
        </span>
        <span className="span param-name">{param}</span>
      </div>
      <div className="list" param-list={param}>
        {copyCountries.map((country) => {
          const { Country, id, flag } = country;
          let cases = country[casesParam];
          if (quality === RELATIVE) {
            cases = Math.round((country[casesParam] * VALUE) / country.population);
          }
          return (
            <Item
              key={id}
              country={Country}
              param={param}
              period={period}
              quality={quality}
              cases={new Intl.NumberFormat({ useGrouping: 'true' }).format(cases)}
              flagURL={flag}
            />
          );
        })}
      </div>
    </div>
  );
}

Statistics.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.shape({
    Country: PropTypes.string,
    length: PropTypes.number,
  })).isRequired,
  global: PropTypes.shape({
    TotalConfirmed: PropTypes.number,
    TotalRecovered: PropTypes.number,
    TotalDeaths: PropTypes.number,
  }).isRequired,
  targetCountryISO2: PropTypes.string.isRequired,
  param: PropTypes.string.isRequired,
  quality: PropTypes.string.isRequired,
  period: PropTypes.string.isRequired,
};
